import { Component, forwardRef, input, signal } from '@angular/core';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ToggleComponent),
    },
  ],
  imports: [ToggleSwitchModule, FormsModule],
})
export class ToggleComponent implements ControlValueAccessor {
  inputId = input<string>(`toggle-${Guid.create().toString()}`);
  label = input<string>();
  disabled = signal(false);

  private valueInternal: boolean;

  get value(): unknown {
    return this.valueInternal;
  }

  set value(value: boolean) {
    this.valueInternal = value;
    this.onChange(value);
    this.onTouched();
  }

  private onTouched: () => void = noop;
  private onChange: (_: unknown) => void = noop;

  writeValue(value: boolean): void {
    this.valueInternal = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
